import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link, withRouter } from 'react-router-dom';
import axios from 'axios';
//import fs from 'fs';
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');
var path = require('path');

class Header extends Component {

    constructor(props) {
        super(props);

  
        this.state = {
            language: [],
            writelanguage:false,
            languagedata:[],
            languagelist:[],
            defaultlang:6,
            Siteconfig:[],
        };
    

          let deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
           deflang = 6;
        }


      
    }





    getlanguagelist(){
      axios.get(`${API_URL}/language`).then(res => {
       
          if(res.data.Status == 1)
          {
            const languagelist = res.data.ResponseData;
           
             localStorage.setItem('LanguageObj',JSON.stringify(languagelist));
            this.setState({languagelist});
               
            
          }else{
            this.setState({languagelist:''});
          }
          })
    }
componentWillMount() {




  const DefaultLang = localStorage.getItem('DefaultLanguage');
  this.setState({defaultlang: DefaultLang});
 
  if(localStorage.getItem('LanguageObj')!=null){
      const LanguageObj=JSON.parse(localStorage.getItem('LanguageObj'));
       this.setState({languagelist:LanguageObj});
  }else{
      this.getlanguagelist();
  }

  if(localStorage.getItem('SiteconfigObj')!=null){
      const SiteconfigObj=JSON.parse(localStorage.getItem('SiteconfigObj'));
       this.setState({Siteconfig:SiteconfigObj});
  }else{
  this.getsiteconfig(DefaultLang);
  }


 // this.getlanguage(DefaultLang);
} 

    getsiteconfig(DefaultLang){
      axios.post(`${API_URL}/siteconfig`, { LanguageId : 6}).then(res => {
            if(res.data.Status == 1)
            {
              const Siteconfig = res.data.ResponseData[0];
               localStorage.setItem('SiteconfigObj',JSON.stringify(Siteconfig));
              this.setState({ Siteconfig });
              
            }else{
              this.setState({ Siteconfig:[] });
            }
            
        })
    }

  handleChange= (event) =>{
         localStorage.setItem('DefaultLanguage',event.target.value);
         this.setState({defaultlang: event.target.value});
         localStorage.setItem('language', false);
         this.getlanguagefile(event.target.value);
         this.getsiteconfig(event.target.value);

         
            
     };
getlanguagefile(defaultlang){
      axios.post(`${API_URL}/langfile`, { LangId:defaultlang}).then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
            console.log("json data",JSON.stringify(data));
             const mythis=this;
             this.setState({ language }); 

             setTimeout(function() { window.location.reload();}.bind(this),1000);
              
                      
            
          }
      })
       
    }
  render() {
    let optionTemplate = this.state.languagelist.map(v => (
      <option value={v.LanguageId} label={v.Language}>{v.Language}</option>
    ));



    return (
  <div>
      <div className="second_header">
  <div className="container-fluid">
    <div className="row">
      <div className="col-xl-7 col-lg-5 col-md-5">
        <nav className="navbar navbar-expand-lg navbar-light">
          
          <Link to="/Home" className="navbar-brand">
              <img src={ IMAGE_URL+'/images/second-logo.png' } alt="Swachh Bharat Abhiyan" />
          </Link>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ol className="navbar-nav mr-auto">
              <li className="nav-item active">
                <Link to="/about-us" className="nav-link">{this.props.languagedata.what_we_do} <span className="sr-only">(current)</span></Link>
              </li>
              <li className="nav-item">
                <Link to="/Programmes" className="nav-link">{this.props.languagedata.programmes}</Link>
              </li>
              <li className="nav-item">
                <Link to="/Volunteer" className="nav-link">{this.props.languagedata.volunteer}</Link>
              </li>
              <li className="nav-item">
                <Link to="/Take-a-Pledge" className="nav-link">{this.props.languagedata.take_a_pledge}</Link>
              </li>
              <li className="nav-item">
                <Link to="/Contact-us" className="nav-link">{this.props.languagedata.contact_us}</Link>
              </li>
            </ol>
          </div>
        </nav>
      </div>
      <div className="col-xl-2 col-lg-3 col-md-3">
        <a href={ "tel:"+this.state.Siteconfig.Phone } className="number" ><i className="fa fa-phone"></i>{ this.state.Siteconfig.Phone }</a>
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2">
        <Link to={this.props.match.path == "/Donate" ? this.props.location.pathname+""+this.props.location.search : "/Donate" } className="donate">{this.props.languagedata.donate_now}</Link>
      </div>
      <div className="col-xl-1 col-lg-2 col-md-2">
      <div className="select_lang2">
          <label for="lang1">Select Language</label>
          <select value={this.state.defaultlang}  onChange={this.handleChange} id="lang1">
              {optionTemplate}
          </select>
          </div>
      </div>
    </div>
  </div>
</div>

<header>
  <div className="container">
  <div className="row">
  <div className="col-lg-12">
  <div className="select_lang">
   <label for="lang2">Select Language</label>
    <select value={this.state.defaultlang}  onChange={this.handleChange} id="lang2">
              {optionTemplate}
          </select>
  </div>
  </div>
  </div>

      <div className="row">            
            <div className="col-xl-10 col-lg-8 col-md-6 ">
              <nav className="navbar navbar-expand-lg navbar-light">
                
                <Link to="/Home" className="navbar-brand">
                <img src={ IMAGE_URL+'/images/logo.png' } alt="Swachh Bharat Mission" />
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
              
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ol className="navbar-nav mr-auto">
                    <li className="nav-item active">
                      <Link to="/about-us" className="nav-link">{this.props.languagedata.what_we_do}<span className="sr-only">(current)</span></Link>
                      
                    </li>
                    <li className="nav-item">
                      <Link to="/Programmes" className="nav-link">{this.props.languagedata.programmes}</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Volunteer" className="nav-link">{this.props.languagedata.volunteer}</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Take-a-Pledge" className="nav-link">{this.props.languagedata.take_a_pledge}</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Contact-us" className="nav-link">{this.props.languagedata.contact_us}</Link>
                    </li>
                  </ol>
                </div>
              </nav>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-3">
              <Link to={this.props.match.path == "/Donate" ? this.props.location.pathname+""+this.props.location.search : "/Donate" } className="donate">{this.props.languagedata.donate_now}</Link>
            </div>
            
        </div>
    </div>
</header>
</div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/layout/Header.js